import { MsgHandler } from '../../core/app/msg/msgHandler';
import * as consts from '../../core/app/common/consts';
import * as aspObjects from '../../core/app/asp/aspObjects';
import { TrackObject } from './TrackObject'
import { ɵConsole } from '@angular/core';
import { AppConfig } from '../../core/app/app.config';


export class ThreatPolygonHandler extends MsgHandler {
  private static _self: ThreatPolygonHandler = null;

  private constructor() {
    super(consts.MSG_TYPE_THREAT_POLYGON);
  }

  public static getSelf(): ThreatPolygonHandler {
    if (this._self == null)
      this._self = new ThreatPolygonHandler();
    return this._self;
  }

  handleMsg(msgObj: any): void {
    if (AppConfig.settings.ShowLogs)
      console.log("threatpolygon msg:", msgObj);
    // search the right track
    let id = "track " + msgObj.TrackId.toString();
    let object = aspObjects.tracksPool.getObject(id) as TrackObject;
    if (!object) { return; }

    if (msgObj.Polygon.length < 4) {
      console.error("Threat Polygon/ABT Polygon has arrived with less than 4 points...");
      object.threatPoly = null;
      object.update();
      return;
    }
    if (object.trackStatus > 1) {
      if (object.threatPoly != null) {
        object.threatPoly = null;
        object.update();
      }
      return;
    }

    object.handleThreat(msgObj);
    object.ForceUpdate = true;
    //update drawing
    object.update();
  }
}
